module.exports = __webpack_public_path__ + "img/Location.a12fbbd5.svg";